// ExamListPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
//const EXAMS_API = `${BASE_URL}/api/exams`;
const SUBJECTS_API = `${BASE_URL}/api/subjects`;


// ============================================================
// DATE/TIME FORMAT HELPERS
// ============================================================

const normalizeDateForInput = (value) => {

    if (!value) {
        return "";
    }


    // Backend now returns YYYY-MM-DD.
    // Do NOT use new Date() here.

    const str = String(value);

    // Already correct:
    // 2026-09-15

    const match =
        str.match(
            /^(\d{4})-(\d{2})-(\d{2})/
        );


    if (match) {

        return (
            `${match[1]}-` +
            `${match[2]}-` +
            `${match[3]}`
        );

    }


    return "";

};


// ============================================================
// TIME FOR INPUT
// ============================================================

const normalizeTimeForInput = (value) => {

    if (!value) {
        return "";
    }


    const str =
        String(value);


    // 12:00
    if (
        /^\d{2}:\d{2}$/.test(str)
    ) {

        return str;

    }


    // 12:00:00
    const match =
        str.match(
            /^(\d{2}):(\d{2})/
        );


    if (match) {

        return (
            `${match[1]}:${match[2]}`
        );

    }


    return "";

};


// ============================================================
// DISPLAY DATE
// ============================================================

const formatDisplayDate = (value) => {

    const date =
        normalizeDateForInput(
            value
        );


    if (!date) {
        return "-";
    }


    const [
        year,
        month,
        day
    ] =
        date.split("-");


    const months = [

        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",

        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"

    ];


    return (
        `${day}-${months[
            Number(month) - 1
        ]}-${year}`
    );

};


// ============================================================
// DISPLAY TIME
// ============================================================

const formatDisplayTime = (value) => {

    const time =
        normalizeTimeForInput(
            value
        );


    if (!time) {
        return "-";
    }


    const [
        hours,
        minutes
    ] =
        time.split(":");


    let hour =
        Number(hours);


    const minute =
        minutes;


    const ampm =
        hour >= 12
            ? "PM"
            : "AM";


    hour =
        hour % 12 || 12;


    return (
        `${String(hour).padStart(2, "0")}:` +
        `${minute} ${ampm}`
    );

};



const ExamPageList = () => {
  const [exams, setExams] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editExam, setEditExam] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [newSubject, setNewSubject] = useState({ SubjectID: "", TotalMarks: "", MinMarks: "", ExamDate: "",
    StartTime: "",
    EndTime: "" });
  const [allSubjects, setAllSubjects] = useState([]);
  const [editSubjectId, setEditSubjectId] = useState(null);
  const [editedSubject, setEditedSubject] = useState({ TotalMarks: "", MinMarks: "" });
  const fetchAllSubjects = () => {
    axios.get(SUBJECTS_API).then((res) => setAllSubjects(res.data));
  };
  useEffect(() => {
    fetchExams();
    fetchAllSubjects();
  }, []);
  // delete subject
const handleDeleteSubject = async (subjectId) => {
  if (!window.confirm("Delete this subject?")) return;
  try {
    const sectionId =
    editExam.SectionID == null
        ? 0
        : editExam.SectionID;
    await axios.delete(
      `${BASE_URL}/api/exams/${editExam.ExamID}/${editExam.CourseID}/${editExam.ClassID}/${sectionId}/${editExam.AcademicYearID}/subjects/${subjectId}`
    );
    alert("Subject deleted");
    handleManageSubjects(editExam);
  } catch (err) {
    alert("Error deleting subject");
  }
};
/*   const handleAddSubject = async () => {
  if (!newSubject.SubjectID || !newSubject.TotalMarks || !newSubject.MinMarks) {
    alert("Please fill all subject details before adding.");
    return;
  }
  try {
    await axios.post(`${BASE_URL}/api/exams/${editExam.ExamID}/subjects`, {
      SubjectID: newSubject.SubjectID,
      TotalMarks: newSubject.TotalMarks,
      MinMarks: newSubject.MinMarks,
      CourseID: editExam.CourseID,
      ClassID: editExam.ClassID,
      SectionID: editExam.SectionID,
      AcademicYearID: editExam.AcademicYearID,
    });
    // refresh subjects
    handleManageSubjects(editExam);
    setNewSubject({ SubjectID: "", TotalMarks: "", MinMarks: "" });
    alert("Subject added successfully ✅");
  } catch (err) {
    console.error("Error adding subject:", err);
    // ✅ Show friendly message if backend provided one
    if (err.response && err.response.data && err.response.data.message) {
      alert(err.response.data.message);
    } else {
      alert("Something went wrong while adding subject. Please try again.");
    }
  }
}; */

//10-9-26
const handleAddSubject = async () => {

    if (
        !newSubject.SubjectID ||
        !newSubject.TotalMarks ||
        !newSubject.MinMarks 
       /*  !newSubject.ExamDate ||
        !newSubject.StartTime ||
        !newSubject.EndTime */
    ) {

        alert(
            "Please fillSubject, Total Marks and Minimum Marks."
        );

        return;
    }

    const today =
        new Date()
            .toISOString()
            .split("T")[0];

    /* if (newSubject.ExamDate < today) {

        alert(
            "Exam Date cannot be before today's date."
        );

        return;
    }

    if (
        newSubject.EndTime <=
        newSubject.StartTime
    ) {

        alert(
            "End Time must be greater than Start Time."
        );

        return;
    } */

    if (
        Number(newSubject.MinMarks) >
        Number(newSubject.TotalMarks)
    ) {

        alert(
            "Minimum Marks cannot be greater than Total Marks."
        );

        return;
    }

    try {

        const sectionId =
            editExam.SectionID == null
                ? null
                : editExam.SectionID;

        await axios.post(
            `${BASE_URL}/api/exams/${editExam.ExamID}/subjects`,
            {
                SubjectID:
                    newSubject.SubjectID,

                TotalMarks:
                    newSubject.TotalMarks,

                MinMarks:
                    newSubject.MinMarks,

                CourseID:
                    editExam.CourseID,

                ClassID:
                    editExam.ClassID,

                SectionID:
                    sectionId,

                AcademicYearID:
                    editExam.AcademicYearID,

                ExamDate:
                    newSubject.ExamDate,

                StartTime:
                    newSubject.StartTime,

                EndTime:
                    newSubject.EndTime
            }
        );

        alert(
            "Subject added successfully."
        );

        await handleManageSubjects(
            editExam
        );

        setNewSubject({
            SubjectID: "",
            TotalMarks: "",
            MinMarks: "",
            ExamDate: "",
            StartTime: "",
            EndTime: ""
        });

    }
    catch (err) {

        console.error(
            "Error adding subject:",
            err
        );

        alert(
            err.response?.data?.message ||
            "Something went wrong while adding subject."
        );
    }
};
  const handleEditSubjectClick = (subject) => {

    setEditSubjectId(subject.SubjectID);

    setEditedSubject({

        TotalMarks:
            subject.TotalMarks ?? "",

        MinMarks:
            subject.MinMarks ?? "",

       /*  ExamDate:
            subject.ExamDate
                ? String(subject.ExamDate).substring(0, 10)
                : "",

        StartTime:
            subject.StartTime
                ? String(subject.StartTime).substring(0, 5)
                : "",

        EndTime:
            subject.EndTime
                ? String(subject.EndTime).substring(0, 5)
                : "" */


         ExamDate:
            normalizeDateForInput(
                subject.ExamDate
            ),

        StartTime:
            normalizeTimeForInput(
                subject.StartTime
            ),

        EndTime:
            normalizeTimeForInput(
                subject.EndTime
            )
    });
};
  const handleCancelEdit = () => {
    setEditSubjectId(null);
    setEditedSubject({ TotalMarks: "", MinMarks: "", ExamDate: "",
        StartTime: "",
        EndTime: "" });
  };
  /* const handleSaveSubject = async () => {
  try {
    await axios.put(
      `${BASE_URL}/api/exams/${editExam.ExamID}/${editExam.CourseID}/${editExam.ClassID}/${editExam.SectionID}/${editExam.AcademicYearID}/subjects/${editSubjectId}`,
      { MinMarks: editedSubject.MinMarks, TotalMarks: editedSubject.TotalMarks }
    );
    alert("Subject updated");
    handleManageSubjects(editExam); // refresh list
    handleCancelEdit();
  } catch (err) {
    alert("Error updating subject");
  }
}; */
//10-9-26
const handleSaveSubject = async () => {

    try {

       /*  if (!editedSubject.ExamDate) {

            alert("Please select Exam Date.");
            return;
        } */

        const today =
            new Date()
                .toISOString()
                .split("T")[0];

       /*  if (
            editedSubject.ExamDate < today
        ) {

            alert(
                "Exam Date cannot be before today's date."
            );

            return;
        } */

       /*  if (
            !editedSubject.StartTime ||
            !editedSubject.EndTime
        ) {

            alert(
                "Please enter Start Time and End Time."
            );

            return;
        } */

       /*  if (
            editedSubject.EndTime <=
            editedSubject.StartTime
        ) {

            alert(
                "End Time must be greater than Start Time."
            );

            return;
        } */


                    // ExamDate, StartTime and EndTime are optional.
        // Backend will use current date/time when blank.

        if (
            editedSubject.ExamDate &&
            editedSubject.ExamDate < today
        ) {
            alert(
                "Exam Date cannot be before today's date."
            );
            return;
        }

        // Validate time only when both are provided
        if (
            editedSubject.StartTime &&
            editedSubject.EndTime &&
            editedSubject.EndTime <= editedSubject.StartTime
        ) {
            alert(
                "End Time must be greater than Start Time."
            );
            return;
        }


        if (
            Number(editedSubject.MinMarks) >
            Number(editedSubject.TotalMarks)
        ) {

            alert(
                "Minimum Marks cannot be greater than Total Marks."
            );

            return;
        }

        const sectionId =
            editExam.SectionID == null
                ? "null"
                : editExam.SectionID;

        await axios.put(

            `${BASE_URL}/api/exams/` +
            `${editExam.ExamID}/` +
            `${editExam.CourseID}/` +
            `${editExam.ClassID}/` +
            `${sectionId}/` +
            `${editExam.AcademicYearID}/` +
            `subjects/${editSubjectId}`,

            {
                MinMarks:
                    editedSubject.MinMarks,

                TotalMarks:
                    editedSubject.TotalMarks,

                ExamDate:
                    editedSubject.ExamDate,

                StartTime:
                    editedSubject.StartTime,

                EndTime:
                    editedSubject.EndTime
            }
        );

        alert(
            "Subject and exam schedule updated successfully."
        );

        await handleManageSubjects(editExam);

        handleCancelEdit();

    }
    catch (err) {

        console.error(
            "Error updating subject:",
            err
        );

        alert(
            err.response?.data?.message ||
            "Error updating subject."
        );
    }
};
  // fetch all exams
  const fetchExams = async (term = "") => {
    try {
      const res = await axios.get(`${BASE_URL}/api/exams`, {
      params: { search: term.trim() || undefined }, // send search if provided
    });
      setExams(res.data);
    } catch (err) {
      console.error("Error fetching exams", err);
    }
  };
  useEffect(() => {
    fetchExams();
  }, []);
// on searchTerm change → fetch exams matching name
useEffect(() => {
  const delayDebounce = setTimeout(() => {
    fetchExams(searchTerm);
  }, 400); // debounce for smoother typing
  return () => clearTimeout(delayDebounce);
}, [searchTerm]);
  // delete exam by examId, courseId, classId, year
  const handleDelete = async (exam) => {
    if (!window.confirm("Are you sure you want to delete this exam?")) return;
    try {
      await axios.delete(
        `${BASE_URL}/api/exams/${exam.ExamID}/${exam.CourseID}/${exam.ClassID}/${exam.SectionID}/${exam.AcademicYearID}`
      );
      alert("Exam deleted successfully");
      fetchExams();
    } catch (err) {
      console.error("Error deleting exam", err);
      alert("Error deleting exam");
    }
  };
  // manage subjects (navigate or call API)
  const handleManageSubjects = async (exam) => {
    try {
      // call backend with params
      const res = await axios.get(
        /* `${BASE_URL}/api/exams/${exam.ExamID}/subjects?courseId=${exam.CourseID}&classId=${exam.ClassID}&yearId=${exam.AcademicYearID}` */
        `${BASE_URL}/api/exams/${exam.ExamID}/${exam.CourseID}/${exam.ClassID}/${exam.SectionID}/${exam.AcademicYearID}/subjects`
      );
       setSubjects(res.data);
    setEditExam(exam);
     console.log("Subjects:", res.data);
      // or redirect to another page if needed
    } catch (err) {
      console.error("Error fetching subjects", err);
      alert("Error loading subjects");
    }
  };
  return (
    <div className="container mt-5">
      <h2 className="mb-4">Exams</h2>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search Exam Name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
           <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>Exam Name</th>
            <th>Course</th>
            <th>Class</th>
            <th>Section</th>
            <th>Academic Year</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {exams.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No exams found
              </td>
            </tr>
          ) : (
            exams.map((exam, index) => (
              <tr key={index}>
                <td>{exam.ExamName}</td>
                <td>{exam.CourseName}</td>
                <td>{exam.ClassName}</td>
                 <td>{exam.SectionName}</td>
                <td>{exam.AcademicYearName}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => handleManageSubjects(exam)}
                  >
                    Manage Subjects
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(exam)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {editExam && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Manage Subjects for: {editExam.ExamName}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditExam(null)}
                ></button>
              </div>
              <div className="modal-body">
                <h6>Subjects</h6>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Subject Name</th>
                       <th>Exam Date</th>

            <th>Start Time</th>

            <th>End Time</th>
                      <th>Total Marks</th>
                      <th>Min Marks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjects.map((subj) => (
                      <tr key={subj.SubjectID}>
                        <td>{subj.SubjectName}</td>

 {/* Exam Date */}

                <td>

                    {editSubjectId === subj.SubjectID ? (

                        <input
                            type="date"
                            className="form-control"
                            min={
                                new Date()
                                    .toISOString()
                                    .split("T")[0]
                            }
                            value={
                                editedSubject.ExamDate
                            }
                            onChange={(e) =>
                                setEditedSubject({
                                    ...editedSubject,
                                    ExamDate:
                                        e.target.value
                                })
                            }
                        />

                    ) : (

                        /* subj.ExamDate
                            ? new Date(
                                subj.ExamDate
                              ).toLocaleDateString(
                                "en-GB"
                              )
                            : "-" */

                           formatDisplayDate(
                            subj.ExamDate
                        )
                    )}

                </td>

                {/* Start Time */}

                <td>

                    {editSubjectId === subj.SubjectID ? (

                        <input
                            type="time"
                            className="form-control"
                            value={
                                editedSubject.StartTime
                            }
                            onChange={(e) =>
                                setEditedSubject({
                                    ...editedSubject,
                                    StartTime:
                                        e.target.value
                                })
                            }
                        />

                    ) : (

                        /* subj.StartTime
                            ? String(
                                subj.StartTime
                              ).substring(0, 5)
                            : "-" */

                          formatDisplayTime(
                            subj.StartTime
                        )
                    )}

                </td>

                {/* End Time */}

                <td>

                    {editSubjectId === subj.SubjectID ? (

                        <input
                            type="time"
                            className="form-control"
                            value={
                                editedSubject.EndTime
                            }
                            onChange={(e) =>
                                setEditedSubject({
                                    ...editedSubject,
                                    EndTime:
                                        e.target.value
                                })
                            }
                        />

                    ) : (

                        /* subj.EndTime
                            ? String(
                                subj.EndTime
                              ).substring(0, 5)
                            : "-" */

                           formatDisplayTime(
                            subj.EndTime
                        )
                    )}

                </td>


                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <input
                              type="number"
                              className="form-control"
                              value={editedSubject.TotalMarks}
                              onChange={(e) =>
                                setEditedSubject({ ...editedSubject, TotalMarks: e.target.value })
                              }
                            />
                          ) : (
                            subj.TotalMarks
                          )}
                        </td>
                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <input
                              type="number"
                              className="form-control"
                              value={editedSubject.MinMarks}
                              onChange={(e) =>
                                setEditedSubject({ ...editedSubject, MinMarks: e.target.value })
                              }
                            />
                          ) : (
                            subj.MinMarks
                          )}
                        </td>
                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <>
                              <button className="btn btn-success btn-sm me-2" onClick={handleSaveSubject}>
                                Save
                              </button>
                              <button className="btn btn-secondary btn-sm" onClick={handleCancelEdit}>
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => handleEditSubjectClick(subj)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDeleteSubject(subj.SubjectID)}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <h6 className="mt-4">Add Subject</h6>
                <div className="row g-2 align-items-end">
                  <div className="col-md-3">
                    <select
                      className="form-select"
                      value={newSubject.SubjectID}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, SubjectID: e.target.value })
                      }
                    >
                      <option value="">Select Subject</option>
                      {allSubjects.map((subj) => (
                        <option key={subj.SubjectID} value={subj.SubjectID}>
                          {subj.SubjectName}
                        </option>
                      ))}
                    </select>
                  </div>

<input
    type="date"
    className="form-control"
    min={
        new Date()
            .toISOString()
            .split("T")[0]
    }
    value={newSubject.ExamDate}
    onChange={(e) =>
        setNewSubject({
            ...newSubject,
            ExamDate: e.target.value
        })
    }
/>

<input
    type="time"
    className="form-control"
    value={newSubject.StartTime}
    onChange={(e) =>
        setNewSubject({
            ...newSubject,
            StartTime: e.target.value
        })
    }
/>

<input
    type="time"
    className="form-control"
    value={newSubject.EndTime}
    onChange={(e) =>
        setNewSubject({
            ...newSubject,
            EndTime: e.target.value
        })
    }
/>



                  <div className="col-md-3">
                    <input
                      type="number"
                      placeholder="Total Marks"
                      className="form-control"
                      value={newSubject.TotalMarks}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, TotalMarks: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="number"
                      placeholder="Min Marks"
                      className="form-control"
                      value={newSubject.MinMarks}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, MinMarks: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <button className="btn btn-success w-100" onClick={handleAddSubject}>
                      Add Subject
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditExam(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ExamPageList;
